import { DateRangePickerValue } from 'shared/mui/DatePicker/DateRangePicker/DateRangePicker';
import { FilterFields } from 'shared/mui/Filter/FilterFields/FilterFields';

import { useUsersListFilterFields } from './hooks/useUsersListFilterFields';

export type UsersListFilterFormValues = {
  appliedDate: [DateRangePickerValue, DateRangePickerValue];
  lastName: string;
  firstName: string;
  roleEntities: string[];
  email: string;
  enabled: string | null;
  reddyNumber: string;
  merchants: string[];
};

export const UsersListFilter: React.FC = () => {
  const fields = useUsersListFilterFields();

  return <FilterFields fields={fields} />;
};
